import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { I18nModule } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule } from "@spartacus/storefront";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CreateUserComponent } from "./create-user.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { KbCustomerIdDropdownModule } from "../../kb-myAccount/kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module";
import { KbMyOwnPartNumbersModule } from "../../kb-myAccount/kb-MyOwnPartNumbers/kbMyOwnPartNumbers.module";
import { UserRightsDialogComponent } from "../user-rights-dialog/user-rights-dialog.component";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { KbMyAccountLeftSideNavModule } from "../../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module";


@NgModule({
   imports: [
      CommonModule,
      FormsModule,
      PageLayoutModule,
      OutletModule,
      OutletRefModule,
      PageSlotModule,
      I18nModule,
      KbMyAccountLeftSideNavModule,
      ReactiveFormsModule,
      KbMyOwnPartNumbersModule,
      MatDialogModule,
      MatIconModule,
      MatButtonModule,
      MatSelectModule,
      MatFormFieldModule,
      MatInputModule,
      KbCustomerIdDropdownModule,
      ReactiveFormsModule
   ],
   providers: [
   ],
   declarations: [CreateUserComponent],
})
export class CreateUserModule {

}
